module.exports = __webpack_public_path__ + "static/testimonial-bg-ad8cb727486b9aef0c392f5cdd98260e.png";